import {Map, fromJS, List} from "immutable";

import {
    GET_SERIES_SUCCESS,
    GET_SERIES_REQUEST,
    GET_SERIES_ERROR,

    CREATE_SERIE_REQUEST,
    CREATE_SERIE_SUCCESS,
    CREATE_SERIE_ERROR,

    UPDATE_SERIE_REQUEST,
    UPDATE_SERIE_SUCCESS,
    UPDATE_SERIE_ERROR,

    DELETE_SERIE_REQUEST,
    DELETE_SERIE_SUCCESS,
    DELETE_SERIE_ERROR,

    CLEAN_SERIES
} from '../actions/series';

const series = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_SERIES_REQUEST:
      case CREATE_SERIE_REQUEST:
      case UPDATE_SERIE_REQUEST:
      case DELETE_SERIE_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_SERIES_SUCCESS:
      case CLEAN_SERIES:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_SERIE_SUCCESS:
          if (action.payload.length > 1) {
              updatedPayload = new List(payload);
              action.payload.forEach( actionPayload => {
                  // Find the index of the serie to be updated inside the List
                  index = updatedPayload.findIndex(item => {
                      return item.get('_id') === actionPayload._id;
                  });
                  // Update the payload list
                  if (index !== -1) {
                      updatedPayload = updatedPayload.update(index, () => {
                          return fromJS(actionPayload);
                      });
                  }
              });
              // Add the new item
              updatedPayload = updatedPayload.push(fromJS(action.payload[action.payload.length-1]));
          } else {
              // Add the new item
              updatedPayload = payload.push(fromJS(action.payload[0]));
          }
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_SERIE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              if (action.payload.length > 1) {
                  updatedPayload = payload;
                  action.payload.forEach( actionPayload => {
                      // Find the index of the work-report to be updated inside the List
                      index = updatedPayload.findIndex(item => {
                          return item.get('_id') === actionPayload._id;
                      });

                      // Update the payload list
                      if (index !== -1) {
                          updatedPayload = updatedPayload.update(index, () => {
                              return fromJS(actionPayload);
                          });
                      }
                  });
              } else {
                  // Find the index of the work-report to be updated inside the List
                  index = payload.findIndex(item => {
                      return item.get('_id') === action.payload[0]._id;
                  });
                  // Update the payload list
                  if (index !== -1) {
                      updatedPayload = payload.update(index, () => {
                          return fromJS(action.payload[0]);
                      });
                  }
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload[0]);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_SERIE_SUCCESS:
          updatedPayload = payload.filter( workReport => {
              return workReport.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_SERIES_ERROR:
      case CREATE_SERIE_ERROR:
      case UPDATE_SERIE_ERROR:
      case DELETE_SERIE_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default series;



// WEBPACK FOOTER //
// ./src/reducers/series.js